
  import {Component, Prop, Vue, Watch} from "vue-property-decorator";
  import {QuestionStatisticsDto} from "@/api/appService";
  import echarts from 'echarts';

    @Component({name:'QuestionStatisticsItem'})
    export default class QuestionStatisticsItem extends Vue{

      @Prop({required:true})
      statisticsData!:QuestionStatisticsDto;

      chartId!:string;

      chart?:any;

      created() {
        this.chartId =   'question-statistics-'+this.statisticsData.topicId;

      }

      mounted(){
        this.renderChart();
      }

      @Watch('statisticsData')
      onStatisticsDataChange(newValue:QuestionStatisticsDto){

        this.renderChart();
      }

      renderChart(){

        let legendData:string[] = [];
        const chartData:any[] = [];
        for(const itemKey in this.statisticsData.result){
          legendData.push(itemKey);
          chartData.push({name:itemKey,value:(this.statisticsData.result as any)[itemKey]});
        }

        const chartOption:any = {
          title: {
            text:'问题:'+ this.statisticsData.topicTitle,
            // subtext: '虚构数据',
            left: 'center'
          },
          tooltip: {
            trigger: 'item',
            formatter: '{b} : {c} ({d}%)'
          },
          legend: {
            // orient: 'vertical',
            // top: 'middle',
            bottom: 10,
            left: 'center',
            data: legendData
          },
          series: [
            {
              type: 'pie',
              radius: '65%',
              center: ['50%', '50%'],
              selectedMode: 'single',
              data: chartData,
              emphasis: {
                itemStyle: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: 'rgba(0, 0, 0, 0.5)'
                }
              }
            }
          ]
        };


        if(!this.chart){
          const ele = document.querySelector('#'+this.chartId);
          this.chart = echarts.init(ele as HTMLDivElement);
        }

        this.chart.setOption(chartOption);

      }




    }
